module.exports = __webpack_public_path__ + "img/howto_h_bg.8789a1f5.png";